import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Breadcrumbs from "@/components/Breadcrumbs";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import BeliefsPage from "@/pages/BeliefsPage";
import BiblePage from "@/pages/BiblePage";
import ChurchSchoolProgramPage from "@/pages/ChurchSchoolProgramPage";
import StartSchoolPage from "@/pages/StartSchoolPage";
import IntakePage from "@/pages/IntakePage";
import ContactPage from "@/pages/ContactPage";
import PrayerRequestPage from "@/pages/PrayerRequestPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import FAQPage from "@/pages/FAQPage";
import LeadershipPage from "@/pages/LeadershipPage";
import OurSchoolsPage from "@/pages/OurSchoolsPage";
import DonatePage from "@/pages/DonatePage";
import MembersPage from "@/pages/MembersPage";
import SermonsPage from "@/pages/SermonsPage";
import DevotionalsPage from "@/pages/DevotionalsPage";
import EventsPage from "@/pages/EventsPage";
import ResourcesPage from "@/pages/ResourcesPage";
import DirectoryPage from "@/pages/DirectoryPage";
import TermsPage from "@/pages/TermsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AlabamaLawPage from "@/pages/AlabamaLawPage";
import PartnerProgramPage from "@/pages/PartnerProgramPage";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ChatWidget from "@/components/ChatWidget";
import OnlineCounter from "@/components/OnlineCounter";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen bg-[#FAF9F6]">
          <Navbar />
          <Breadcrumbs />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/beliefs" element={<BeliefsPage />} />
              <Route path="/bible" element={<BiblePage />} />
              <Route path="/church-school-program" element={<ChurchSchoolProgramPage />} />
              <Route path="/start-a-church-school" element={<StartSchoolPage />} />
              <Route path="/get-started" element={<IntakePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/prayer-request" element={<PrayerRequestPage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/leadership" element={<LeadershipPage />} />
              <Route path="/our-schools" element={<OurSchoolsPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/members" element={<MembersPage />} />
              <Route path="/members/sermons" element={<SermonsPage />} />
              <Route path="/members/devotionals" element={<DevotionalsPage />} />
              <Route path="/members/events" element={<EventsPage />} />
              <Route path="/members/resources" element={<ResourcesPage />} />
              <Route path="/members/directory" element={<DirectoryPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:postId" element={<BlogPostPage />} />
              <Route path="/alabama-church-school-law" element={<AlabamaLawPage />} />
              <Route path="/partner-program" element={<PartnerProgramPage />} />
              <Route path="/customer" element={<CustomerDashboard />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <ChatWidget />
        <OnlineCounter />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
